import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getCurrentLanguage, t } from 'translation'
import { setLanguage } from 'store/actions'

const SettingsLanguageSelect = ({ closeLanguageSelectHandler, setLanguage }) => {
  const languages = ['en', 'fr']
  const currentLanguage = getCurrentLanguage()
  const setCurrentLanguageHandler = (lang) => (e) => {
    e.stopPropagation()
    setLanguage(lang)
    closeLanguageSelectHandler()
  }

  return (
    <div className="popup_in right_pos_mod">
      <ul className="popup_group right_level_mod" onClick={(e) => e.stopPropagation()}>
        {languages.map((lang) => (
          <li
            key={lang}
            className={`popup_group_item ${
              lang === currentLanguage ? 'popup_group_item_selected' : ''
            }`}
          >
            <button
              className="popup_group_link default_text"
              onClick={setCurrentLanguageHandler(lang)}
            >
              {t(`settings.${lang.toUpperCase()}`)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

const willMapDispatchToProps = { setLanguage }

export default connect(null, willMapDispatchToProps)(SettingsLanguageSelect)

SettingsLanguageSelect.propTypes = {
  closeLanguageSelectHandler: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
}
